import { i18n } from "@/resources/locales";
import axios from "axios";

export class SpaceService {
  async getSpacesAvailable(): Promise<any> {
    return await axios.get("api/spaces");
  }
  async getSpacesPaginate(id, page, name): Promise<any> {
    if (name) {
      return await axios.get(`api/spaces_by_web_client?name=${name}&page=${page}`);
    }
    if (id)
      return await axios.get(`api/spaces_by_web_client?superSpace.id=${id}&page=${page}&itemsPerPage=60`);
  }
  async getSpace(spaceId: number): Promise<any> {
    return await axios.get(`api/spaces/${spaceId}`);
  }
  async getRoom(roomId: number): Promise<any> {
    return await axios.get(`api/rooms/${roomId}`);
  }

  async getPoster(id: number): Promise<any> {
    return await axios.get(`api/posters/${id}`);
  }
  async getSceneTypes(spaceType: string, superSpaceId: number): Promise<any> {
    let parametter = "";
    if (spaceType) parametter = `?spaceType=${spaceType}`;
    return await axios.get(`api/scenario_types${parametter}&superSpaceId=${superSpaceId}`);
  }
  async updateSpace(spaceId: number, data: any): Promise<any> {
    return await axios.put(`api/spaces/${spaceId}`, data);
  }
  async updateScene(spaceId: number, data): Promise<any> {
    return await axios.put(`api/spaces/${spaceId}/change_scenario`, data);
  }
  async uploadSceneFile(data): Promise<any> {
    return await axios.post(`api/scenario_files`, data);
  }
  async uploadSpaceFile(data): Promise<any> {
    return await axios.post(`api/space_files`, data);
  }
  async sendConsoleMessage(spaceId, data): Promise<any> {
    return await axios.post(`api/console_message/space/${spaceId}`, data);
  }
  async sendConsoleMessageMultiSpace(superSpaceId, data): Promise<any> {
    return await axios.post(
      `api/console_message/super_space/${superSpaceId}`,
      data
    );
  }
  /*async updateRoomInfo(scenarioId: number, data): Promise<any> {
    return await axios.put(`/api/scenarios/${scenarioId}/edit_rooms`, data);
  }*/
  async updateRoomInfo(roomId: number, data): Promise<any> {
    return await axios.put(`api/rooms/${roomId}`, data);
  }
  async updateRoomImage(data): Promise<any> {
    return await axios.post(`api/room_files`, data);
  }
  async updatePoster(id: number, data): Promise<any> {
    return await axios.put(`api/posters/${id}`, data);
  }
  async updatePosterImage(data): Promise<any> {
    return await axios.post(`api/poster_files`, data);
  }
  async activeSpace(token: string): Promise<any> {
    return await axios.post(`api/spaces/activate/${token}`, {});
  }
  async generateUrlInvitation(spaceId: number): Promise<any> {
    return await axios.post(
      `api/spaces/${spaceId}/generate_guest_invitation_token`,
      {}
    );
  }
  async generateUserUrlInvitation(spaceId: number): Promise<any> {
    return await axios.post(
      `api/spaces/${spaceId}/generate_user_invitation_token`,
      {}
    );
  }
  async getGlobalParams(): Promise<any> {
    return await axios.get(`api/global_params?locale=${i18n.locale}`);
  }
  async sendEmojiReaction(spaceId: number, data): Promise<any> {
    return await axios.post(`api/spaces/${spaceId}/send_emoji_reaction`, data);
  }

  async deleteSpace(id: number): Promise<any> {
    return await axios.delete(`api/spaces/${id}`);
  }

  async enabledOrDisabledSpaceBySuperAdmin(id: number, data): Promise<any> {
    return await axios.put(`api/spaces/${id}/enable_by_super_admin`, data);
  }
  async enabledOrDisabledSpace(id: number, data): Promise<any> {
    return await axios.put(`api/spaces/${id}/enable`, data);
  }
  async getRequestSpaces(page): Promise<any> {
    return await axios.get(`api/request_spaces?page=${page}`);
  }

  async createNewSpace(data): Promise<any> {
    return await axios.post(`api/spaces/request`, data);
  }

  async changeRoomPin(roomId, data): Promise<any> {
    return await axios.put(`api/rooms/${roomId}/change_pin`, data);
  }

  async removeAllPin(spaceId): Promise<any> {
    return await axios.post(`api/spaces/${spaceId}/release_all_room_pins`, {});
  }

  async sendInfoUser(spaceId: number, userId: number): Promise<any> {
    return await axios.post(
      `/api/spaces/${spaceId}/send_info_to_email/${userId}`,
      {}
    );
  }

  async addToFavourite(spaceId: number, data: any): Promise<any> {
    return await axios.post(`api/spaces/${spaceId}/add_to_favourites`, data);
  }

  async getFavouriteSpaces(page: number): Promise<any> {
    return await axios.get(`api/spaces/favourites`);
  }

  async updateRoomNotes(roomId, data): Promise<any> {
    return await axios.put(`api/rooms/${roomId}/edit_notes`, data);
  }

  async getRoomNotes(roomId, pin): Promise<any> {
    if (pin != "null" && pin != null)
      return await axios.get(`api/rooms/${roomId}/notes?pinToJoin=${pin}`);
    else
      return await axios.get(`api/rooms/${roomId}/notes`);
  }

  async removeImageSpace(imageId: number) {
    return await axios.delete(`/api/space_files/${imageId}`);
  }

  async removeImagePoster(imageId: number) {
    return await axios.delete(`/api/poster_files/${imageId}`);
  }

  async removeImageRoom(imageId: number) {
    return await axios.delete(`/api/room_files/${imageId}`);
  }

  async createByTeams(data: any) {
    return await axios.post(`/api/spaces/create_by_teams`, data);
  }

  async createGroup(superSpaceId: number, data: any) {
    return await axios.post(`/api/super_spaces/${superSpaceId}/groups`, data);
  }

  async getGroups(superSpaceId: number) {
    return await axios.get(`/api/super_spaces/${superSpaceId}/groups`);
  }

  async editGroup(groupId: number, data: any) {
    return await axios.put(`/api/groups/${groupId}`, data);
  }

  async removeGroup(groupId: number) {
    return await axios.delete(`/api/groups/${groupId}`);
  }

  async getUsersGroup(groupId: number) {
    return await axios.get(`/api/groups/${groupId}`);
  }

  async setUsersGroup(groupId: number, data: any) {
    return await axios.put(`/api/groups/${groupId}/manage_users`, data);
  }

  async getAllSpaces(superSpaceId: number, page: number) {
    return await axios.get(`/api/spaces/list_with_basic_info?superSpace.id=${superSpaceId}&page=${page}&itemsPerPage=60`);
  }
}
